const PUBLIC_ROUTE_PREFIXES = ["/space/records/public/"];
const REDIRECT_EXEMPT_PATHS = ["/login", "/signup"];
export type AuthRedirectReason = "invalid" | "expired" | "unverified" | "blocked";

function isPublicPath(pathname: string): boolean {
  return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function isRedirectExemptPath(pathname: string): boolean {
  return (
    isPublicPath(pathname) ||
    REDIRECT_EXEMPT_PATHS.some((exemptPath) => pathname === exemptPath)
  );
}

export function redirectToLoginIfNeeded(reason: AuthRedirectReason = "invalid"): void {
  if (typeof window === "undefined") {
    return;
  }

  const pathname = window.location.pathname || "/";
  if (isRedirectExemptPath(pathname)) {
    return;
  }

  const params = reason ? new URLSearchParams({ auth: reason }) : new URLSearchParams();
  window.location.href = `/login${params.toString() ? `?${params.toString()}` : ""}`;
}

export function isPublicRoute(pathname: string): boolean {
  return isPublicPath(pathname);
}
